import React, { useEffect, useRef, useState } from "react";

import { FabricJSCanvas, useFabricJSEditor } from "fabricjs-react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { Document, Page, pdfjs } from "react-pdf/dist/esm/entry.webpack";

import ControlPanel from "../ControlPanel";
import Loader from "../Loader";

import "./styles.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const PDFReader = props => {
  const [firstRendered, setFirstRendered] = useState(true);
  const [readedPagesAux, setReadedPagesAux] = useState([]);
  const [scale, setScale] = useState(1.0);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [showNav, setShowNav] = useState(false);
  const [showDropdownPencil, setDropdownPencil] = useState(false);
  const [cursorState, setCursorState] = useState(true);
  const [activePencil, setActivePencil] = useState(false);
  const [activeRectangle, setActiveRectangle] = useState(false);
  const [renderedPageNumber, setRenderedPageNumber] = useState();

  const [addTextEnabled, setAddTextEnabled] = useState(false);
  const [addRectEnabled, setAddRectEnabled] = useState(false);

  const [rectFillColor, setRectFillColor] = useState("#00FFFF");
  const [rectOpacity, setRectOpacity] = useState(0.3);

  const [isLoading, setIsLoading] = useState(true);
  const isLoadingPage = renderedPageNumber !== pageNumber;

  const [spacing, setSpacing] = useState(60);

  const [canvasHeight, setCanvasHeight] = useState(`400px`);
  const [canvasWidth, setCanvasWidth] = useState("400px");

  const [pagesLoaded, setPagesLoaded] = useState([]);

  /* Salvar JSON */
  const [prevPage, setPrevPage] = useState(1);
  const [pageAnnotations, setPageAnnotations] = useState(props.pageAnnotations);
  const [aux, setAux] = useState(true);

  const [canvasFlag, setCanvasFlag] = useState(true);

  const [eventTrigger, setEventTrigger] = useState(true);

  const itemEl = useRef();
  const sideBarPage = useRef([]);

  // Refazer e Desfazer
  const [change, setChange] = useState(null);
  const [changeDel, setChangeDel] = useState(null);
  const [stackMain, setStackMain] = useState([]);
  const [stackAux, setStackAux] = useState([]);
  const [triggeredPrev, setTriggeredPrev] = useState(false);

  // Inicialização do Fabric, para adição do Canvas.
  const { editor, onReady, updated } = useFabricJSEditor();

  const isFirstPage = pageNumber === 1;
  const isLastPage = pageNumber === numPages;

  const goToPreviousPage = () => {
    if (!isFirstPage && pageNumber) {
      setPageNumber(pageNumber - 1);
    }
  };
  const goToNextPage = () => {
    if (!isLastPage) {
      setPageNumber(pageNumber + 1);
    }
  };

  useEffect(() => {
    if (pageNumber && numPages) {
      window.removeEventListener("keydown", handleKeys, true);
      window.addEventListener("keydown", handleKeys, true);

      return () => {
        window.removeEventListener("keydown", handleKeys, true);
      };
    }
  }, [pageNumber, numPages]);

  // Ativar o evento que lê a tecla
  useEffect(() => {
    if (editor && aux) {
      setPageNumber(props.lastPageOpened);
      editor.loadJson(props.documentJSON);
      setAux(false);

      let arr = loadNavbarPages();
      setPagesLoaded(arr);

      editor.changeCanvas(setChange, setChangeDel); // ativa o listener no index.modern.js
    }

    if (firstRendered && numPages) {
      if (props.readedPages.length === 0) {
        // Atualizando o array de páginas lidas
        let arr = takePages();
        setReadedPagesAux(arr);
        setFirstRendered(false);
      } else {
        setReadedPagesAux(
          props.readedPages.splice(readedPagesAux.indexOf(pageNumber), 1)
        );
        setFirstRendered(false);
      }
    }
  });

  const takePages = () => {
    let arr = [];
    if (numPages) {
      for (let i = 1; i < numPages; i++) {
        arr.push(i + 1);
      }
    }
    return arr;
  };

  useEffect(() => {
    let array = [...pageAnnotations];

    if (editor) {
      let curAnnotations = editor.saveJson();
      array[prevPage] = curAnnotations;

      setPageAnnotations(array);
    }

    // Chama evento "onChange"
    props.onChange({
      pageNumber,
      numPages,
      pageAnnotations: array,
      force: true
    });

    // Encontra o index e o exclui
    const stackMain1 = [...stackMain];

    stackMain1.push(changeDel);
    setStackMain(stackMain1);
  }, [changeDel]);

  useEffect(() => {
    let array = [...pageAnnotations];

    if (editor) {
      let curAnnotations = editor.saveJson();
      array[prevPage] = curAnnotations;

      setPageAnnotations(array);
    }

    // Chama evento "onChange"
    props.onChange({
      pageNumber,
      numPages,
      pageAnnotations: array,
      force: true
    });

    // Pesquisa se já existe esse JSON
    const all = [...stackMain, ...stackAux];
    const exist = all.includes(change);

    if (!exist && !triggeredPrev) {
      // se não existir e se acionou
      setStackAux([]);
    }

    const arr = [...stackMain, change];

    if (arr[0] === null) {
      arr.shift();
    }
    // Tira json duplicado
    let novaArr = arr.filter((este, i) => arr.indexOf(este) === i);

    setStackMain(novaArr);
    setTriggeredPrev(false);
  }, [change]);

  // Função para mexer nas Stacks
  const previousState = () => {
    if (stackMain.length !== 0) {
      let x = [...stackMain];
      if (x.length > 1) {
        let lastElement = x.pop(); // pega o último elemento
        setStackAux([...stackAux, lastElement]);
        setStackMain(x);

        // const currentEl = x.pop();
        const currentEl = x[x.length - 1];

        editor.loadJson(currentEl);
        setTriggeredPrev(true);
      } else {
        let lastElement = x.pop();
        setStackAux([...stackAux, lastElement]);
        setStackMain([]);

        editor.loadJson('{"version":"4.5.1","objects":[]}');
        setTriggeredPrev(true);
      }
    } else {
      setTriggeredPrev(false);
    }
  };

  const nextState = () => {
    if (stackAux.length !== 0) {
      let x = [...stackAux];
      if (x.length > 1) {
        let lastElement = x.pop(); // pega o último elemento

        setStackMain([...stackMain, lastElement]);
        setStackAux(x);

        editor.loadJson(lastElement);
      } else {
        let lastElement = x.pop();
        setStackMain([...stackMain, lastElement]);
        setStackAux([]);

        editor.loadJson(lastElement);
      }
    }
  };

  // Sempre que a escala mudar, dá um resize no Canvas
  useEffect(() => {
    resizeCanvas();
  }, [scale]);

  /* Salva JSON */
  useEffect(() => {
    let array = [...pageAnnotations];

    if (editor) {
      let curAnnotations = editor.saveJson();
      array[prevPage] = curAnnotations;

      setPageAnnotations(array);
      setPrevPage(pageNumber);

      if (pageAnnotations[pageNumber]) {
        editor.loadJson(pageAnnotations[pageNumber]);
      } else {
        editor.loadJson('{"version":"4.5.1","objects":[]}');
      }
    }

    // Atualiza o array de páginas lidas
    if (readedPagesAux.includes(pageNumber)) {
      readedPagesAux.splice(readedPagesAux.indexOf(pageNumber), 1);
    }

    // Chama evento "onChange"
    props.onChange({ pageNumber, numPages, pageAnnotations: array });

    /* Scroll sidebar */
    if (sideBarPage.current[pageNumber]) {
      sideBarPage.current[pageNumber].scrollIntoView({ block: "center" });
      sideBarPage.current[prevPage].style.opacity = "0.6";
      sideBarPage.current[pageNumber].style.opacity = "1";
    }

    /* Reseta as Stacks */
    setStackMain([]);
    setStackAux([]);
  }, [pageNumber]);

  /* Desce a página da SideBar */
  useEffect(() => {
    if (sideBarPage.current[pageNumber]) {
      sideBarPage.current[pageNumber].scrollIntoView({ block: "center" });
      sideBarPage.current[prevPage].style.opacity = "0.6";
      sideBarPage.current[pageNumber].style.opacity = "1";
    }
  }, [showNav]);

  // Tratamento do Loading do PDF
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
    setIsLoading(false);
  };

  // Retorna um array com número de todas as páginas

  // Carregamento de todas as páginas para SideBar
  const loadNavbarPages = () => {
    let array = [];
    for (let i = 1; i <= numPages; i++) {
      array.push(<div style={{ marginBottom: `20px` }}></div>);
      array.push(
        <div
          className="pageSideBar"
          onClick={() => {
            setPageNumber(i);
          }}
          ref={ref => (sideBarPage.current[i] = ref)}
        >
          <Page
            className="page-class"
            pageNumber={i}
            renderAnnotationLayer={false}
            width={250}
            renderMode="canvas"
            loading="Carregando"
            renderTextLayer={false}
          />
        </div>
      );
    }
    return array;
  };

  // Função para lidar com a inserção de texto na posição correta.
  const handleClick = event => {
    if (addTextEnabled) {
      editor.addText("Insira seu texto", event);
      setAddTextEnabled(false);
      setCursorState(true);
      setAddRectEnabled(false);
    } else if (addRectEnabled) {
      editor.addRectangle(event, rectFillColor, rectOpacity);
      setAddRectEnabled(false);
      setActiveRectangle(false);
      setCursorState(true);
      setActivePencil(false);
    }
  };

  // Função para fazer funcionar a tecla delete.
  const handleKeyPress = e => {
    if (e.key === "Delete") {
      editor.deleteSelected();
    }
    if (e.key === 46) {
      // MacOS
      editor.deleteSelected();
    }
  };

  const handleKeys = e => {
    if ((e.key === "p" || e.key === "P") && e.ctrlKey) {
      e.preventDefault();
    }

    if (e.key === "ArrowLeft") {
      e.preventDefault();
      if (pageNumber > 1) setPageNumber(pageNumber - 1);
    }

    if (e.key === "ArrowRight") {
      e.preventDefault();
      if (pageNumber < numPages) {
        setPageNumber(pageNumber + 1);
      }
    }
  };

  const handleWheel = e => {
    // Rolar para baixo
    if (e.deltaY > 0) {
      if (
        pageNumber < numPages &&
        itemEl.current.getBoundingClientRect().bottom + spacing <=
          window.innerHeight
      ) {
        setPageNumber(pageNumber + 1);
        itemEl.current.scrollIntoView(true);
        // document.body.scrollTop = 0;
        // document.documentElement.scrollTop = 0;
      }
    }
    // Rolar para cima
    else if (
      pageNumber > 1 &&
      itemEl.current.getBoundingClientRect().top >= itemEl.current.offsetTop
    ) {
      setPageNumber(pageNumber - 1);
      itemEl.current.scrollIntoView(false);
    }
  };

  // Função que dá o resize no canvas
  const resizeCanvas = () => {
    if (itemEl.current) {
      let { height } = itemEl.current.getBoundingClientRect();
      let { width } = itemEl.current.getBoundingClientRect();

      setCanvasHeight(`${height}px`);
      setCanvasWidth(`${width}px`);
      editor.setDimensions(width, height);
      editor.zoomSet(scale);
    }
  };

  // //Assim que mexer o mouse, corrigir o Canvas. É o trigger do tamanho do Canvas.
  const handleMouseMove = () => {
    if (itemEl.current && canvasFlag) {
      resizeCanvas();
      setCanvasFlag(false);
    }
  };

  return (
    <>
      <Loader id="loader" isLoading={isLoading} />

      {/* Painel de Controle Superior */}
      <div className="panel-div">
        <ControlPanel
          className="control-panel"
          scale={scale}
          setScale={setScale}
          numPages={numPages}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          // pageScroll={handleNavigation}
          file={props.src}
          setShowNav={setShowNav}
          showNav={showNav}
          setDropdownPencil={setDropdownPencil}
          showDropdownPencil={showDropdownPencil}
          editor={editor}
          textFlag={setAddTextEnabled}
          addTextEnabled={addTextEnabled}
          rectFlag={setAddRectEnabled}
          rectFunctions={{ fill: setRectFillColor, opacity: setRectOpacity }}
          setCanvasHeight={setCanvasHeight}
          cursorState={cursorState}
          setCursorState={setCursorState}
          activePencil={activePencil}
          setActivePencil={setActivePencil}
          activeRectangle={activeRectangle}
          setActiveRectangle={setActiveRectangle}
          enablePrint={props.enablePrint}
          enableSave={props.enableSave}
          previousState={previousState}
          nextState={nextState}
        />
      </div>

      {/* SideBar */}
      <div className={showNav ? "sidenav active" : "sidenav"}>
        <Document
          file={props.src}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadProgress={({ loaded, total }) => {}}
        >
          {pagesLoaded.map((item, index) => item)}
        </Document>
      </div>

      <div style={{ display: "flex", alignItems: "center" }}>
        {numPages && (
          <div className="buttonNav" onClick={goToPreviousPage}>
            <IoIosArrowBack />
          </div>
        )}

        {/* Main */}
        <section
          onMouseMove={handleMouseMove}
          // onWheel={handleWheel}
          // onKeyDown={handleKeys}
          id="pdf-section"
          className="d-flex flex-column align-items-center w-100"
        >
          <Document
            file={props.src}
            onLoadSuccess={onDocumentLoadSuccess}
            loading="Carregando arquivo"
            error="Erro ao carregar o arquivo"
          >
            <div ref={element => (itemEl.current = element)}>
              {isLoadingPage && renderedPageNumber ? (
                <Page
                  className="prevPage"
                  key={renderedPageNumber}
                  pageNumber={renderedPageNumber}
                  scale={scale}
                  renderAnnotationLayer={false}
                  renderMode="canvas"
                  loading=""
                />
              ) : null}
              <Page
                className={isLoadingPage ? "isLoading" : ""}
                key={pageNumber}
                // pageNumber={pageNumber}
                pageNumber={pageNumber}
                onRenderSuccess={() => setRenderedPageNumber(pageNumber)}
                scale={scale}
                renderAnnotationLayer={false}
                renderMode="canvas"
                loading=""
              />
            </div>
            <div style={{ height: `${spacing}px` }}></div>
          </Document>

          {numPages && (
            <div
              id="fabric"
              onClick={handleClick}
              onKeyDown={handleKeyPress}
              tabIndex="-1"
              style={{
                outline: "none",
                height: canvasHeight,
                width: canvasWidth
              }}
            >
              <FabricJSCanvas onReady={onReady} className="sample-canvas" />
            </div>
          )}
        </section>

        {numPages && (
          <div className="buttonNav" onClick={goToNextPage}>
            <IoIosArrowForward />
          </div>
        )}
      </div>
    </>
  );
};

export default PDFReader;
